$ = require 'jquery'
Browser = require '@trello/browser'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
_ = require 'underscore'

# Mixin
module.exports = class AutoInsertionView

  checkInsert: (e) ->
    key = Keyboard.getKey(e)

    if PopOver.isVisible && !Browser.isTouch()
      if (e.shiftKey && (key in [Keys.ArrowUp, Keys.ArrowDown])) or (e.altKey && (key in [Keys.ArrowUp, Keys.ArrowDown]))
        return

      else if key == Keys.Escape
        Util.stop(e)
        PopOver.hide()
        return

      else
        autoCompleters = [
          { listClass: '.js-available-members', itemClass: '.js-select-member' }
          ( listClass: '.js-available-emoji', itemClass: '.js-select-emoji')
          ( listClass: '.js-card-list', itemClass: '.js-select-card')
        ]

        for { listClass, itemClass } in autoCompleters
          $available = $('.pop-over').find(listClass)
          if $available.length > 0
            if key in [Keys.Enter, Keys.Tab]
              Util.stop(e)
              # Make sure we've updated the list with everything we've typed
              if $available.find('.item:first').hasClass('selected')
                @keyAutoMention(e)
                # This might cause the list to re-write, so we have to get the
                # items back out of the DOM
                $available = $('.pop-over').find(listClass)

              $available
                .find(".item.selected:first #{ itemClass }")
                .first()
                .click()

              PopOver.hide()
              return false

            else if key in [Keys.ArrowUp, Keys.ArrowDown]
              Util.stop(e)
              Util.navMenuList($available, '.item', key)
              return false

  keyAutoMention: (e) ->
    if !Browser.isTouch()
      if Keyboard.isArrow(Keyboard.getKey(e)) || Keyboard.getKey(e) == Keys.Enter
        return

      if Keyboard.getKey(e) == Keys.Escape
        if PopOver.isVisible
          Util.stop(e)
        return

      word = Util.getWordFromCaret(@getTextInput())

      if ///^@\S///.test(word.str.substring(0, 2))

        # Because the function that determines who to show is
        # locked up in the view, we need to load the view first
        # to determine if there is anything to show in the popover.
        # We won't show it if there isn't anybody that matches.

        return @getAutoMentionerView('input')
        .then (view) =>
          if view.filterMentionablesForMatches(word.str.substring(1).toLowerCase()).length == 0
            PopOver.hide()
            return

          PopOver.show
            elem: @getMentionTarget()
            view: view
            keepEdits: true

          if !@getTextInput().is(':focus')
            @getTextInput().focus()
          return

      else if /^:[a-z0-9_]+$/.test(word.str)
        emojiView = @getEmojiCompleterView('input')

        PopOver.show
          elem: @getEmojiTarget()
          view: emojiView
          keepEdits: true

        if !@getTextInput().is(':focus')
          @getTextInput().focus()
        return

      @setTimeout ->
        PopOver.hide()
      , 5



// WEBPACK FOOTER //
// ./app/scripts/views/internal/autocomplete/auto-insertion-view.coffee